"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBadge = IconBadge;
const jsx_runtime_1 = require("react/jsx-runtime");
const class_variance_authority_1 = require("class-variance-authority");
const IconBadgeVariants = (0, class_variance_authority_1.cva)("ko:rounded-full ko:p-2 ko:w-fit", {
    variants: {
        color: {
            primary: "ko:text-primary ko:bg-primary/10",
            secondary: "ko:text-secondary ko:bg-secondary/10",
            neutral: "ko:text-neutral ko:bg-neutral/10",
        },
    },
    defaultVariants: {
        color: "primary",
    },
});
function IconBadge({ children, color }) {
    return (0, jsx_runtime_1.jsx)("div", { className: IconBadgeVariants({ color }), children: children });
}
